// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraFilledSvg from "@fishx/icons-svg/es/asn/VideoCameraFilled";
import FishxIcon from '../components/FishxIcon';

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraFilledSvg
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
export default React.forwardRef(VideoCameraFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VideoCameraFilled.js
// module id = 4376
// module chunks = 0